module.exports = __webpack_public_path__ + "img/login_icon4.e170cdf5.png";